module.exports = __webpack_public_path__ + "static/rendering3_mini-660f40a9254715205803c027da48fb4e.png";